import * as angular from 'angular';

import { ComponentDefinition, ImportResult } from '../../../models';
import { ILoggerService } from '../../../services';

class ImportModalController implements angular.IComponentController {
    fileList: FileList;
    import: ImportResult;
    isUploading: boolean;

    readonly entity: string;
    readonly modalId: string;
    readonly title: string;
    readonly upload: (value: { file: File }) => angular.IPromise<ImportResult>;

    static $inject = [
        'loggerService'
    ];

    constructor(
        private _loggerService: ILoggerService
    ) {
    }

    callUpload() {
        this.isUploading = true;
        this.upload({ file: this.fileList[0] })
            .then(result => this.import = result)
            .catch(reason => this._loggerService.logError(reason.data?.Message ?? reason))
            .finally(() => {
                this.isUploading = false;
                this.fileList = undefined;
            });
    }

    reset(): void {
        this.import = undefined;
        this.fileList = undefined;
    }
}

export const wtImportModal: ComponentDefinition = {
    componentId: 'wtImportModal',
    controller: ImportModalController ,
    template: require('./importModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        entity: '@',
        modalCaptionNo: '<?', 
        modalId: '@',
        title: '@',
        upload: '&',
    }
};